import { compose, withHandlers, withState } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { fetchShop } from '../../shops/actions';
import { getShopByRoute, getAllowMultipleServices } from '../../shops/selectors';
import { generateUrlString, toggleItemInArray } from '../../utils/helpers';
import { fetchServices } from '../../services/actions';
import { commonServicesProvider } from '../../services/hoc';
import Services from './Services';
import analytics from '../../applicationServices/analytics/BookingAnalytics';
import { getServiceName } from '../../services/selectors';

const fetchData = compose(
  withRouter,
  connect(null, { fetchServices, fetchShop }),
  withHandlers({
    fetchData: props => () =>
      props
        .fetchShop(props.params.shopRoute)
        .then(() =>
          props.fetchServices(props.params.shopRoute, props.params.barberRoute, props.params, props.urlPattern),
        ),
  }),
);

const generateUrl = compose(
  withRouter,
  connect((state, ownProps) => ({
    shop: getShopByRoute(state, ownProps.params.shopRoute),
    allowMultipleServices: getAllowMultipleServices(state, ownProps.params.shopRoute),
    getServiceNames: serviceId => getServiceName(state, serviceId),
  })),
  withHandlers({
    generateUrlString: props => params =>
      generateUrlString(
        {
          ...props.params,
          ...params,
        },
        props.urlPattern,
      ),
  }),
  withState('selectedIds', 'setSelectedService', ''),
  withState('nextLink', 'setNextLink', ''),
  withHandlers({
    onServiceClick: props => id => (e) => {
      const serviceId = (() => {
        if (!props.allowMultipleServices) return id;
        if (!props.selectedIds) return id;

        return toggleItemInArray(props.selectedIds.split(';'), id).join(';');
      })();

      props.setSelectedService(() => serviceId);

      const nextLink = props.generateUrlString({ serviceId });

      // No need to show next link if only one service can be booked at a time
      if (!props.allowMultipleServices) {
        e.preventDefault();

        return props.router.push(nextLink);
      }

      props.setNextLink(() => nextLink);

      return true;
    },
  }),
);

export default compose(
  fetchData,
  generateUrl,
  commonServicesProvider,
  withHandlers({
    onNextClick: props => () => {
      analytics.selectService(props.getServiceNames(props.selectedIds), { shop: props.shop });
    },
  })
)(Services);



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/services/ServicesContainer.js